import React from 'react';
import { IconInvoiceOutline, IconCreditCardOutline, IconQuestionOutline } from '@saucelabs/ds-icons';
import { List } from 'immutable';
import { connect, useDispatch, useSelector } from 'react-redux';

import { NavigationItem } from './Layout/NavigationItem';
import { trackEvent, EVENTS } from './../tracking';
import Subscription from '../records/Subscription';
import { actions, selectors } from '../ducks/subscriptions';

interface SideNavigationProps {
  showBillingInformation?: boolean,
  showCreditsFAQ?: boolean,
}

const SideNavigation: React.FC<SideNavigationProps> = ({
  showBillingInformation = true,
  showCreditsFAQ = false,
}) => (
  <div className="flex ml-auto">
    {showBillingInformation && (
      <NavigationItem
        href="/billing/billing-information"
        icon={IconCreditCardOutline}
        onClick={() => trackEvent(EVENTS.NAVIGATION_CLICK_BILLING_INFO)}
        text="Billing Information"
      />
    )}
    <NavigationItem
      href="/billing/invoices"
      icon={IconInvoiceOutline}
      onClick={() => trackEvent(EVENTS.NAVIGATION_CLICK_INVOICES)}
      text="Invoices"
    />
    {showCreditsFAQ && (
      <NavigationItem
        href="/billing/about-credits"
        icon={IconQuestionOutline}
        text="About Credits"
      />
    )}
  </div>
);

const SideNavigationContainer: React.FC<SideNavigationProps> = ({
  showCreditsFAQ, ...props
}) => {
  const subscriptions = useSelector(selectors.getSubscriptionsSelector);

  return (
    <SideNavigation
      showCreditsFAQ={showCreditsFAQ && subscriptions?.some(
        (sub) => sub?.plan.isUsage() || false)}
      {...props}
    />
  );
};

export default SideNavigationContainer;
